module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/hustler.png?fa086a222a308e3faa48c565543e439b";